import PatientDocumentDialog from './PatientDocumentDialog';

export default PatientDocumentDialog;
